<script>
  export let isOpen = false;
  export let project = null;
  export let isAdmin = false; // 관리자 여부 추가
  
  function handleClose() {
    isOpen = false;
  }

  // 상태 라벨 매핑
  const statusLabels = {
    'active': '모집중',
    'deleted': '삭제됨',
    'open': '채용 시 마감',
    'closed': '상시 채용'
  };

  // 날짜 포맷 함수
  function formatDate(dateString) {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('ko-KR');
  }

  // 배열을 문자열로 변환 (빈 배열이면 '-' 반환)
  function arrayToString(arr) {
    if (!arr || arr.length === 0) return '-';
    return Array.isArray(arr) ? arr.join(', ') : arr;
  }
</script>

{#if isOpen && project}
  <div class="modal-overlay" on:click={handleClose} on:keydown={(e) => e.key === 'Escape' && handleClose()}>
    <div class="modal-container" on:click|stopPropagation on:keydown={(e) => e.key === 'Escape' && handleClose()}>
      <div class="modal-header">
        <h3>프로젝트 상세 정보</h3>
        <button class="close-modal-btn" on:click={handleClose}>✕</button>
      </div>
      
      <div class="modal-content">
        <div class="detail-section">
          <h4>기본 정보</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">프로젝트 제목</span>
              <span class="detail-value">{project.title || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">회사명</span>
              <span class="detail-value">{project.company || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">카테고리</span>
              <span class="detail-value">{project.category || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">상태</span>
              <span class="detail-value status-{project.status}">
                {statusLabels[project.status] || project.status}
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">개발자 등급/경력</span>
              <span class="detail-value">{project.level || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">인원 수</span>
              <span class="detail-value">{project.headcount || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">근무 위치</span>
              <span class="detail-value">{project.location || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">급여 정보</span>
              <span class="detail-value">{project.salary || '-'}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">시작일</span>
              <span class="detail-value">{formatDate(project.startDate) || formatDate(project.start_date)}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">종료일</span>
              <span class="detail-value">{formatDate(project.endDate) || formatDate(project.end_date)}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">등록일</span>
              <span class="detail-value">{formatDate(project.created_at)}</span>
            </div>
          </div>
        </div>

        <!-- 기술 스택 -->
        <div class="detail-section">
          <h4>기술 스택</h4>
          <div class="detail-content">
            <div class="skills-list">
              {#if project.skills && project.skills.length > 0}
                {#each project.skills as skill}
                  <span class="skill-tag">{skill}</span>
                {/each}
              {:else}
                <span class="no-data">등록된 기술 스택이 없습니다</span>
              {/if}
            </div>
          </div>
        </div>

        <!-- 자격 요건 -->
        <div class="detail-section">
          <h4>자격 요건</h4>
          <div class="detail-content">
            <div class="requirements-list">
              {#if project.requirements && project.requirements.length > 0}
                {#each project.requirements as requirement}
                  <div class="requirement-item">• {requirement}</div>
                {/each}
              {:else}
                <span class="no-data">등록된 자격 요건이 없습니다</span>
              {/if}
            </div>
          </div>
        </div>

        <!-- 우대 사항 -->
        <div class="detail-section">
          <h4>우대 사항</h4>
          <div class="detail-content">
            <div class="preferred-list">
              {#if project.preferredSkills && project.preferredSkills.length > 0}
                {#each project.preferredSkills as preferred}
                  <div class="preferred-item">• {preferred}</div>
                {/each}
              {:else}
                <span class="no-data">등록된 우대 사항이 없습니다</span>
              {/if}
            </div>
          </div>
        </div>

        <!-- 프로젝트 설명 -->
        <div class="detail-section">
          <h4>프로젝트 상세 설명</h4>
          <div class="detail-content">
            <div class="description-content">
              {#if project.description}
                <p>{project.description}</p>
              {:else}
                <span class="no-data">등록된 상세 설명이 없습니다</span>
              {/if}
            </div>
          </div>
        </div>

        <!-- 연락처 정보 -->
        <div class="detail-section">
          <h4>연락처 정보</h4>
          <div class="detail-content">
            <div class="contact-content">
              {#if project.contact}
                <p>{project.contact}</p>
              {:else}
                <span class="no-data">등록된 연락처 정보가 없습니다</span>
              {/if}
            </div>
          </div>
        </div>

        <!-- 관리자 비고 (관리자만 표시) -->
        {#if isAdmin}
          <div class="detail-section admin-notes-section">
            <h4 class="admin-notes-title">
              👑 관리자 비고
            </h4>
            <div class="detail-content admin-notes-content">
              <div class="admin-notes-text">
                {#if project.admin_notes}
                  <p><strong>비고:</strong> {project.admin_notes}</p>
                {:else}
                  <span class="no-data">등록된 관리자 비고가 없습니다</span>
                {/if}
                
                {#if project.admin_remark}
                  <p><strong>비고 2:</strong> {project.admin_remark}</p>
                {/if}
              </div>
            </div>
          </div>
        {/if}
      </div>
      
      <div class="modal-footer">
        <div class="modal-actions-right">
          <button class="modal-btn cancel" on:click={handleClose}>닫기</button>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  /* Modal Overlay */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(2px);
    transition: all 0.3s ease;
  }

  /* Modal Container */
  .modal-container {
    background: var(--color-white);
    border-radius: var(--border-radius-xl);
    box-shadow: var(--shadow-2xl);
    max-width: 800px;
    width: 90%;
    max-height: 90vh;
    overflow: hidden;
    position: relative;
    transform: scale(0.9);
    transition: transform 0.3s ease;
  }

  .modal-overlay .modal-container {
    transform: scale(1);
  }

  /* Modal Header */
  .modal-header {
    padding: var(--spacing-lg);
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark) 100%);
    color: var(--color-white);
    border-top-left-radius: var(--border-radius-xl);
    border-top-right-radius: var(--border-radius-xl);
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .modal-header h3 {
    margin: 0;
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-semibold);
    color: var(--color-white);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .close-modal-btn {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    font-size: var(--font-size-lg);
    color: var(--color-white);
    cursor: pointer;
    padding: var(--spacing-2);
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radius-full);
    transition: var(--transition-all);
    backdrop-filter: blur(10px);
  }

  .close-modal-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }

  /* Modal Content */
  .modal-content {
    padding: var(--spacing-lg);
    overflow-y: auto;
    max-height: calc(90vh - 140px);
  }

  /* Detail Sections */
  .detail-section {
    margin-bottom: var(--spacing-6);
    background-color: var(--color-white);
    border: 1px solid var(--color-gray-200);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-5);
  }

  .detail-section h4 {
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-semibold);
    color: var(--color-gray-900);
    margin-bottom: var(--spacing-4);
    padding-bottom: var(--spacing-3);
    border-bottom: 2px solid var(--color-primary-light);
    display: flex;
    align-items: center;
    gap: var(--spacing-2);
  }

  .detail-section h4::before {
    content: '';
    width: 4px;
    height: 20px;
    background-color: var(--color-primary);
    border-radius: var(--border-radius-full);
  }

  .detail-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: var(--spacing-5);
  }

  .detail-item {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
    padding: var(--spacing-3);
    background-color: var(--color-gray-25);
    border-radius: var(--border-radius);
    border-left: 3px solid var(--color-primary-light);
  }

  .detail-label {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
    color: var(--color-gray-600);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: var(--spacing-1);
  }

  .detail-value {
    font-size: var(--font-size-base);
    color: var(--color-gray-900);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-relaxed);
    min-height: 24px;
    display: flex;
    align-items: center;
  }

  .detail-content {
    background-color: var(--color-gray-50);
    border: 1px solid var(--color-gray-200);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-5);
    font-size: var(--font-size-base);
    line-height: var(--line-height-relaxed);
    white-space: pre-wrap;
    color: var(--color-gray-800);
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .skills-list {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-sm);
  }

  .skill-tag {
    background-color: var(--color-primary);
    color: var(--color-white);
    padding: var(--spacing-xs) var(--spacing-sm);
    border-radius: var(--border-radius);
    font-size: 0.875rem;
    font-weight: 500;
  }

  .requirements-list,
  .preferred-list {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
  }

  .requirement-item,
  .preferred-item {
    font-size: 0.95rem;
    color: var(--color-gray-800);
    line-height: 1.5;
  }

  .description-content,
  .contact-content {
    line-height: 1.6;
  }

  .description-content p,
  .contact-content p {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .no-data {
    color: var(--color-gray-500);
    font-style: italic;
  }

  /* Modal Footer */
  .modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-5) var(--spacing-6);
    border-top: 1px solid var(--color-gray-200);
    background-color: var(--color-gray-25);
    border-bottom-left-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);
  }

  .modal-actions-right {
    display: flex;
    gap: var(--spacing-3);
  }

  /* Modal Button */
  .modal-btn {
    padding: var(--spacing-2) var(--spacing-4);
    border: none;
    border-radius: var(--border-radius);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-medium);
    cursor: pointer;
    transition: var(--transition-all);
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-1);
    min-width: 80px;
    justify-content: center;
  }

  .modal-btn:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
  }

  .modal-btn.cancel {
    background-color: var(--color-gray-500);
    color: var(--color-white);
    border: 1px solid var(--color-gray-500);
  }

  .modal-btn.cancel:hover {
    background-color: var(--color-gray-600);
    border-color: var(--color-gray-600);
  }

  /* 상태별 색상 */
  .status-active {
    color: var(--color-success);
    font-weight: 600;
  }

  .status-deleted {
    color: var(--color-danger);
    font-weight: 600;
  }

  .status-open {
    color: var(--color-warning);
    font-weight: 600;
  }

  .status-closed {
    color: var(--color-info);
    font-weight: 600;
  }

  /* 관리자 비고 섹션 스타일 */
  .admin-notes-section {
    border: 2px solid var(--color-primary, #007bff);
    border-radius: 8px;
    background-color: #f8f9ff;
    margin-bottom: 100px;
  }

  .admin-notes-title {
    color: var(--color-primary, #007bff) !important;
    border-bottom-color: var(--color-primary, #007bff) !important;
  }

  .admin-notes-content {
    background-color: #f0f4ff !important;
    border-color: var(--color-primary, #007bff) !important;
  }

  .admin-notes-text {
    font-style: italic;
    color: var(--color-primary, #007bff);
  }

  /* 반응형 모달 */
  @media (max-width: 768px) {
    .modal-container {
      margin: var(--spacing-2);
      max-width: none;
      width: calc(100% - var(--spacing-4));
    }
    
    .modal-footer {
      flex-direction: column;
      gap: var(--spacing-3);
    }
    
    .modal-actions-right {
      width: 100%;
      justify-content: center;
    }
    
    .modal-btn {
      flex: 1;
      min-width: auto;
    }
    
    .detail-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 480px) {
    .modal-overlay {
      padding: var(--spacing-xs);
      align-items: flex-start;
      padding-top: 10vh;
    }
    
    .modal-container {
      width: 100%;
      max-width: 100%;
      margin: 0;
      border-radius: var(--border-radius-md);
    }
    
    .modal-header h3 {
      font-size: var(--font-size-lg);
    }
  }
</style> 